import React, { useState } from "react";
import boat from "../../../../asset/images/boat.svg";
import truck from "../../../../asset/icons/truck.svg";
import trash from "../../../../asset/images/trash.png";
import Input from "component/form/Input";
import SupportDocs from "component/form/supportDocs";
import ShipmentAddressInput from "./ShipmentAddressInput";
import AssignShippingAgent from "./AssignShippingAgent";
import { Form, Nav, NavDropdown } from "react-bootstrap";
import { EditUnderlineIcon, ProfileFilledIcon } from "asset/icons";
import capitalizeWords from "utilities/capitalizeWords";

const ShippingLeg = ({
    leg,
    index,
    updateShippingLeg,
    removeShippingLeg,
    shippingLegs,
    setSelectedUser,
    selectedUser,
    setShowMore,
    showMore,
}) => {
    const [show, setShow] = useState(false);
    const [addDocs, setAddDocs] = useState(false);
    const calendarMinDate = new Date().toISOString().split("T")[0];

    const changeShipmentType = () => {
        updateShippingLeg(
            leg.id,
            "type",
            leg.type === "Truck"
                ? "Sea Freight"
                : leg.type === "Sea Freight"
                ? "Truck"
                : "Sea Freight"
        );
    };


    return (
        <>
            <div className="my-3">
                {/* Shipping Leg Header */}
                <div className="flex items-center justify-between p-3 bg-white rounded-md cursor-pointer">
                    <div
                        // onClick={() => setShowMore((c) => !c)}
                        className="flex items-center justify-start w-full gap-2 m-0"
                    >
                        <div
                            className={`flex items-center justify-center p-2 rounded-full size-10 bg-gray-100`}
                        >
                            <img
                                src={leg.type === "Truck" ? truck : boat}
                                alt="Boat | Truck Icon"
                                className={"size-6"}
                            />
                        </div>{" "}
                        <span className="flex items-center gap-2 text-bold">
                            Leg {index} :{" "}
                            <Nav>
                                <NavDropdown className="" title={leg.type}>
                                    <NavDropdown.Item
                                        onClick={() => {
                                            changeShipmentType();
                                        }}
                                        className=""
                                    >
                                        Sea freight
                                    </NavDropdown.Item>
                                    <NavDropdown.Item
                                        onClick={() => {
                                            changeShipmentType();
                                        }}
                                        className=""
                                    >
                                        Truck
                                    </NavDropdown.Item>
                                </NavDropdown>
                            </Nav>
                        </span>
                    </div>

                    <div className="flex items-center justify-center gap-3">
                        <span
                            className="text-xs font-semibold cursor-pointer !text-secondary"
                            onClick={() =>
                                setShowMore((prev) => {
                                    if (index === prev) {
                                        return (prev = null);
                                    } else {
                                        return (prev = index);
                                    }
                                })
                            }
                        >
                            {showMore === index ? "Hide" : "View"}
                        </span>
                        {shippingLegs?.length > 1 && (
                            <span>
                                <img
                                    src={trash}
                                    alt=""
                                    style={{ cursor: "pointer" }}
                                    onClick={() => removeShippingLeg(leg.id)}
                                />
                            </span>
                        )}
                    </div>
                </div>

                {showMore === index && (
                    <div className="pt-4 pl-3 mb-5 ml-3 border-l border-[#F2F3FC]">
                        <div className="flex flex-col gap-[8px] w-full my-3">
                            <p className="text-[14px] leading-[19.6px] font-medium	text-gray-10">
                                Shipment Route
                            </p>
                            <ShipmentAddressInput
                                leg={leg}
                                updateShippingLeg={updateShippingLeg}
                                name="departurePort"
                            />
                            <ShipmentAddressInput
                                leg={leg}
                                name="destinationPort"
                                shipmentType="Destination Port"
                                updateShippingLeg={updateShippingLeg}
                            />
                        </div>

                        <div className="flex flex-col gap-[8px] w-full my-3">
                            <Input
                                label="Add Shipping Line"
                                placeholder="Enter shipping Line"
                                name="shippingLine"
                                value={leg.shippingLine}
                                onChange={(e) => updateShippingLeg(leg.id, "shippingLine", e)}
                            />
                        </div>

                        <div className="flex flex-col gap-[8px] w-full my-3">
                            {leg?.clearingAgent ? (
                                <>
                                    <label
                                        htmlFor=""
                                        className="text-[14px] leading-[19.6px] font-medium	text-gray-10 mb-1"
                                    >
                                        Assign Clearing Agent
                                    </label>
                                    <div
                                        onClick={() => {
                                            leg?.clearingAgent
                                                ? updateShippingLeg(leg.id, "clearingAgent", null)
                                                : setSelectedUser(null);
                                            setShow(true);
                                        }}
                                        className="bg-white rounded-lg !p-4 flex items-center relative cursor-pointer"
                                    >
                                        <input
                                            required
                                            defaultValue={leg?.clearingAgent?._id}
                                            className="absolute top-0 left-0 h-full -z-30"
                                        />

                                        <ProfileFilledIcon className="rounded-full mr-1.5 -ml-1 -my-0.5" />
                                        <span className="font-[450] mr-auto text-main-dark">
                                            {capitalizeWords(
                                                leg?.clearingAgent?.name?.toLowerCase()
                                            )}
                                        </span>

                                        <EditUnderlineIcon className="size-[22px]" />
                                    </div>
                                </>
                            ) : (
                                <AssignShippingAgent
                                    isAgent={leg.isClearingAgent}
                                    updateShippingLeg={updateShippingLeg}
                                    leg={leg}
                                    setSelectedUser={setSelectedUser}
                                    selectedUser={selectedUser}
                                    show={show}
                                    setShow={setShow}
                                />
                            )}
                            <div
                                htmlFor=""
                                className="text-[14px]  leading-[19.6px] font-medium mt-2 text-gray-10"
                            >
                                <Form.Check
                                    type="checkbox"
                                    label="I am the Clearing Agent"
                                    checked={leg.isClearingAgent}
                                    onChange={(e) => {
                                        updateShippingLeg(leg.id, "clearingAgent", null);
                                        updateShippingLeg(
                                            leg.id,
                                            "isClearingAgent",
                                            e.target.checked
                                        );
                                    }}
                                    custom
                                    id="custom-checkbox"
                                    style={{
                                        "--bs-form-check-input-bg-checked": "#6C47FF !important",
                                        "--bs-form-check-input-check-color-checked":
                                            "#ffffff  !important",
                                        "--bs-form-check-input-border-color-checked":
                                            "#6C47FF  !important",
                                        boxShadow: "none",
                                    }}
                                    className="[&>*]:!shadow-none custom-checkbox"
                                />
                            </div>
                        </div>

                        <div className="flex flex-col gap-[8px] w-full mb-4">
                            <Input
                                type="date"
                                label="Drop Off Date"
                                placeholder="01-03-2024"
                                name="dropOffDate"
                                value={leg.dropOffDate}
                                min={calendarMinDate}
                                onChange={(e) => updateShippingLeg(leg.id, "dropOffDate", e)}
                            />
                        </div>

                        <SupportDocs
                            addDocs={addDocs}
                            setAddDocs={setAddDocs}
                            file={leg.document}
                            leg={leg}
                            setFile={(file) =>
                                updateShippingLeg(leg.id, "document", {
                                    name: file?.name,
                                    url: file?.url,
                                })
                            }
                            onDelete={() => {
                                updateShippingLeg(leg.id, "document", {});
                            }}
                            showDelete={true}
                        />

                        {shippingLegs.length > 1 && (
                            <button
                                className="!text-secondary mt-4"
                                onClick={() => removeShippingLeg(leg.id)}
                            >
                                - Remove Shipping Leg
                            </button>
                        )}
                    </div>
                )}
            </div>
        </>
    );
};

export default ShippingLeg